import type { OrgaViewFrameContext } from "../../../context"

export const canViewOrganizationSettings = (context: OrgaViewFrameContext) =>
  context.permissions.allows("core.org_settings", "view") ||
  context.permissions.allows("core.org_settings", "manage")

export const isSubscriptionRestricted = (context: OrgaViewFrameContext) =>
  context.subscriptionRestrictionActive && !context.permissions.isSuper

export const canDeleteOrganization = (context: OrgaViewFrameContext) =>
  Boolean(
    context.organization &&
    context.permissions.allows("core.org_settings", "manage") &&
    (context.permissions.isSuper || context.currentUserOrganizationId === context.organization.id),
  )

export const canViewBilling = (context: OrgaViewFrameContext) => {
  const authorized =
    context.permissions.allows("core.billing", "view") ||
    context.permissions.allows("core.billing", "manage")

  if (!context.billingAvailable || !context.billingEnabled || !authorized) return false

  return (
    context.billingRequiresCheckout ||
    context.tariffCapabilities.hasUsage ||
    context.permissions.allows("core.billing", "manage")
  )
}
